import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CommentsComponent } from './components/comments/comments.component';
import { SljComponent } from './components/slj/slj.component';
import { HbookComponent } from './components/hbook/hbook.component';
import { LoginComponent } from './components/login/login.component';

const routes: Routes = [
  { path: 'lj', component: CommentsComponent },
  { path: 'slj', component: SljComponent },
  { path: 'hbook', component: HbookComponent },
  { path: 'login', component: LoginComponent },
  { path: '', redirectTo: '/login', pathMatch: 'full'},
]

@NgModule({
  declarations: [],
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'enabled',
      anchorScrolling: 'enabled',
      scrollOffset: [0, 64],
    }),
  ],
  exports: [
    RouterModule
  ]
})
export class AppRoutingModule { }
